import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Advertising, AdvertisingGroup } from "@/savaradio/common";

export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false,
  upload: false
}

export type IsLoading = Record<keyof typeof initialLoading, boolean>;

export type StoreOptions = {
  duration: number,
  interval: number
}
const initialState: { value?: AdvertisingGroup[], isLoading: IsLoading } = {
  isLoading: initialLoading
}

const advertisingSlice = createSlice({
  name: "advertising_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Advertising>) => {
      if (!state.value) state.value = [{
        _id: action.payload.client!,
        count: 1,
        advertisings: [action.payload]
      }]
      else {
        const target_advertising_group = state.value.find(advertising_group => advertising_group._id === action.payload.client)
        if (
          target_advertising_group &&
          !target_advertising_group.advertisings.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(advertising_group => {
            if (advertising_group._id === target_advertising_group._id) return {
              ...target_advertising_group,
              count: target_advertising_group.count + 1,
              advertisings: [...target_advertising_group.advertisings, action.payload]
            }
            else return advertising_group
          })
        }
        if (!target_advertising_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.client!,
              count: 1,
              advertisings: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Advertising>) => {
      if (state.value) {
        const target_advertising_group = state.value.find(advertising_group => advertising_group._id === action.payload.client)
        if (target_advertising_group) {
          state.value = state.value.map(advertising_group => {
            if (advertising_group._id === target_advertising_group._id) return {
              ...target_advertising_group,
              count: target_advertising_group.count - 1,
              advertisings: target_advertising_group.advertisings.filter(advertising => advertising._id !== action.payload._id)
            }
            return advertising_group
          })
        }
      }
    },
    merge: (state, action: PayloadAction<Advertising>) => {
      if (state.value) {
        const target_advertising_group = state.value.find(advertising_group => advertising_group._id === action.payload.client)
        if (target_advertising_group) {
          state.value = state.value.map(advertising_group => {
            if (advertising_group._id === target_advertising_group._id) return {
              ...target_advertising_group,
              advertisings: target_advertising_group.advertisings.map(advertising => advertising._id === action.payload._id ? action.payload : advertising)
            }
            return advertising_group
          })
        }
        else {
          state.value = state.value.map(advertising_group => ({
            ...advertising_group,
            advertisings: advertising_group.advertisings.filter(advertising => advertising._id !== action.payload._id)
          })).concat([{
            _id: action.payload.client!,
            count: 1,
            advertisings: [action.payload]
          }])
        }
      }
    },
    reset: (state, action: PayloadAction<AdvertisingGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading, ...action.payload
      }
    }
  }
})

export const { append, pop, merge, reset, setLoading } = advertisingSlice.actions

export const advertising_slice = advertisingSlice.reducer